import { h } from "preact";
import {
  formatSize,
  validateBigFile,
  validateDeniedType,
  validateEmptyFile,
} from "./tools";

export const allowedFileTypes = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "doc",
  "docx",
  "rtf",
  "xls",
  "xlsx",
  "zip",
  "sig",
  "xml",
];
export const maxSizeFile = 20971520; //20Mb 1024*1024*20
export const maxCountFile = 20;

export const renderFileRow = (file, key, field, onDeleteFile, fileParams) => {
  let errorFile = [];

  const allowedTypes =
    (typeof fileParams !== "undefined" && fileParams["allowedFileTypes"]) ||
    allowedFileTypes;
  const maxSize =
    (typeof fileParams !== "undefined" && fileParams["maxSizeFile"]) ||
    maxSizeFile;
  const maxCount =
    (typeof fileParams !== "undefined" && fileParams["maxCountFile"]) ||
    maxCountFile;
  if (validateBigFile(maxSize)(file))
    errorFile.push("Ограничение на размер файлов " + formatSize(maxSize));
  if (validateDeniedType(allowedTypes)(file))
    errorFile.push("Допустимый формат файлов: " + allowedTypes.join(", "));
  if (validateEmptyFile(file)) errorFile.push("Нельзя отправить пустой файл");
  if (key > maxCount - 1)
    errorFile.push("Нельзя отправить более " + maxCount + " файлов");

  return (
    <li
      className={`file-input__files-item ${
        errorFile.length ? "file-input__files-item_error" : ""
      }`}
      key={file.name + file.size}
    >
      <span className="file-input__files-item-name">{file.name}</span>
      <span className="file-input__files-item-size">
        {formatSize(file.size)}
      </span>
      <button
        className="file-input__files-item-delete"
        aria-label="Удалить файл"
        onClick={onDeleteFile(file, field)}
      />
      {errorFile.map((errorItem) => (
        <p className="file-input__files-item-error-text">{errorItem}</p>
      ))}
    </li>
  );
};

/**
 *
 * @description calculates progress for displaying
 * @param currentProgress
 * @param speed
 * @param uploadProgressBarInterval
 * @returns {number}
 */
export const calculateProgress = (
  currentProgress,
  speed,
  uploadProgressBarInterval
) => {
  // recalculate it manually to create
  let calculatedProgress =
    currentProgress +
    (speed - (speed * currentProgress) / 100) *
      (uploadProgressBarInterval / 1000);
  // round and return
  return Math.min(calculatedProgress, 100);
};

/**
 *
 * @param min
 * @param max
 * @returns {*}
 */
export const randomFromInterval = (min, max) => {
  return Math.random() * (max - min) + min;
};
